import React from "react";
import { cn } from "utils";
import { I18nUtil } from "@utils";
import Translations from "@translate/components/Loading/DotsLoading";
// import { ospThemes } from "@ospweb/sdk-ui";

const I18n = I18nUtil.createScoped(Translations);

export interface DotsLoadingProps {
  /**
   * 文字颜色
   * @type string
   * @default '#666'
   */
  color?: string;

  /**
   * 自定义类名
   * @type string
   * @default ''
   */
  className?: string;
  textClassName?: string;
}

/**
 * 加载中...动画效果组件
 */
export const DotsLoading: React.FC<DotsLoadingProps> = ({
  className = "",
  textClassName = "",
}) => {
  return (
    <div
      className={`inline-flex items-center ${className}`}
      // style={{ color }}
    >
      <style>
        {`
          .dots-loading::after {
            content: '';
            animation: dots-loading 2s steps(5, end) infinite;
          }
          @keyframes dots-loading {
            0%, 20% { content: '.'; }
            40% { content: '..'; }
            60% { content: '...'; }
            80%, 100% { content: '.'; }
          }
        `}
      </style>
      <span className={cn("dots-loading text-content_primary", textClassName)}>
        {I18n.t("Thinking")}
      </span>
    </div>
  );
};
